<template>
    <li class="listItem">
        <AppCheckbox
            :value="actives.includes(item.id)"
            :label="item.title"
            @input="$emit('toggleItem', item)"
        />
        <ul
            v-if="item.children"
            class="listLevel list-reset"
        >
            <ListItem
                v-for="(levelItems, index) in item.children"
                :key="index"
                :item="levelItems"
                :actives="actives"
                @toggleItem="item => $emit('toggleItem', item)"
            />
        </ul>
    </li>
</template>

<script>
import AppCheckbox from '../form/AppCheckbox.vue';

export default {
    name: 'ListItem',
    components: {
        AppCheckbox,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
        actives: {
            type: Array,
            required: true,
        },
    },
};
</script>

<style lang="postcss" scoped>
.listItem {
    margin-bottom: 10px;
    &:last-child {
        margin-bottom: 0;
    }
    & >>> .label {
        font-size: 15px;
        @media (--laptop) {
            font-size: 14px;
        }
    }
    & ul {
        display: none;
        padding-left: 22px;
    }
}
.isChecked + ul {
    display: block;
}
</style>
